import { marked } from "marked";
import termsPt from "@/content/terms/pt-BR.md";
import termsEn from "@/content/terms/en-US.md";
import termsEs from "@/content/terms/es-ES.md";
import privacyPt from "@/content/privacy/pt-BR.md";
import privacyEn from "@/content/privacy/en-US.md";
import privacyEs from "@/content/privacy/es-ES.md";

const LANGUAGE_MAP = {
  portuguese: "pt-BR",
  english: "en-US",
  spanish: "es-ES",
};

const FALLBACK_LOCALE = "pt-BR";

const markdownFiles = {
  terms: {
    "pt-BR": termsPt,
    "en-US": termsEn,
    "es-ES": termsEs,
  },
  privacy: {
    "pt-BR": privacyPt,
    "en-US": privacyEn,
    "es-ES": privacyEs,
  },
};

export function getMarkdown(type, currentLanguage) {
  const locale = LANGUAGE_MAP[currentLanguage] || FALLBACK_LOCALE;
  const files = markdownFiles[type];
  return files[locale] || files[FALLBACK_LOCALE];
}

export function markdownToHtml(content) {
  return marked.parse(content, {
    gfm: true,
    breaks: false,
    headerIds: false,
  });
}
